import React from "react";
function Options({ value, label }) {
  return /* @__PURE__ */ React.createElement("option", { value, key: value }, label);
}
const renderOptions = (options = [], label = "Choose One", loading = false) => {
  if (loading) {
    return Options({ value: "", label: "Loading..." });
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("option", { value: "" }, label), options.map((option) => Options({ value: option.value, label: option.label })));
};
export default Options;
export { renderOptions };
